export const AUTH_KEY = 'AUTH_KEY';
export const AUTH_INIT = 'AUTH_INIT';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILED = 'AUTH_FAILED';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_SETLINK = 'AUTH_SETLINK';
export const AUTH_CLEAR = 'AUTH_CLEAR';
